// components/ProtectedRoute.jsx
import React from "react";
import PageNotFound from "../pages/404/PageNotFound";

const ProtectedRoute = ({ adminOnly = false, children }) => {
    const user = JSON.parse(localStorage.getItem("user"));

    // No user logged in → show 404
    if (!user) {
        return <PageNotFound />;
    }

    // If route is admin-only and user is not ADMIN → show 404
    if (adminOnly && user?.userType !== "ADMIN") {
        return <PageNotFound />;
    }

    return children;
};

export default ProtectedRoute;
